// extracted by mini-css-extract-plugin
export var closeButton = "_fh-2";
export var closeButtonIcon = "_fh-3";
export var lightboxContent = "_fh-1";
export var lightboxOverlay = "_fh-0";